import { useSorting } from '@/hooks/use-sorting.ts';

type TSortOrder = 'ascend' | 'descend' | null | undefined;

export const useDefaultSortOrder = (): ((field: string) => TSortOrder) => {
    const { sort } = useSorting();

    return (field: string): TSortOrder => {
        if (!sort.sort_by || sort.sort_by !== field || !sort.sort_direction) return undefined;

        return sort.sort_direction === 'asc' ? 'ascend' : 'descend';
    };
};
